import React from 'react';
import { useAtnaConversation } from '../../hooks/useAtnaConversation';
import { AtnaDialogShell } from '../atna/AtnaDialogShell';
import { AtnaMessage } from './AtnaMessage';
import type { AtnaTurnKind } from '../../types/demandes';
interface AtnaConversationDialogProps {
  initialText: string;
  onClose: () => void;
  /** Shared layout id: the launcher pill morphs into this panel. */
  layoutId: string;
}
export function AtnaConversationDialog({
  initialText,
  onClose,
  layoutId
}: AtnaConversationDialogProps) {
  const {
    turns,
    thinking,
    draft,
    setDraft,
    submitDraft,
    description,
    intent,
    setIntent,
    setAddress,
    address,
    answer,
    setAnswer,
    hasPhoto,
    attachPhoto,
    exchange,
    detect,
    liveAtnaId,
    lastAtnaKind
  } = useAtnaConversation(initialText);
  return <AtnaDialogShell layoutId={layoutId} subtitle="Report a problem" onClose={onClose} turns={turns} thinking={thinking} liveAtnaId={liveAtnaId} footnote="ATNA can make mistakes. Check the summary before sending your request." prompt={{
    value: draft,
    onChange: setDraft,
    onSubmit: submitDraft,
    onAddPhoto: attachPhoto,
    photoAttached: hasPhoto,
    placeholder: lastAtnaKind === 'succes' ? 'Anything else to report?' : 'Reply to ATNA, or add detail to your request…'
  }} renderAtna={(kind, live) => <AtnaMessage kind={kind as AtnaTurnKind} live={live} intent={intent} address={address} description={description} answer={answer} hasPhoto={hasPhoto} onConfirmIntent={() => exchange('Yes, that’s it', 'lieu')} onPickIntent={setIntent} onNotEmergency={() => {
    setIntent(detect(description));
    exchange('This is not an emergency', 'comprehension');
  }} onPickAddress={(picked, source) => {
    setAddress(picked);
    exchange(source === 'position' ? `My location: ${picked}` : picked, hasPhoto ? 'detail' : 'photo');
  }} onAddPhoto={attachPhoto} onSkipPhoto={() => exchange('Continue without a photo', 'detail')} onAnswer={option => {
    setAnswer(option);
    exchange(option, 'revue');
  }} onSend={() => exchange('Send my request', 'succes')} onEdit={() => exchange('I want to change my request', 'comprehension')} onReset={onClose} data-id="element-692" data-mp="1cdbplju5wtla" />} data-id="element-691" data-mp="2z1uqgyv3gnrj" />;
}